export const CheckoutGuestComponent = {
    require: {
        checkout: '^checkoutStep'
    },
    template: `
        <oo-card>
            <oo-card-header>
                Not logged in? <a ui-sref="checkout" ng-click="$ctrl.popupLogin()">Log In Here</a>
            </oo-card-header>
        </oo-card>
        <basic-info-guest></basic-info-guest>
        <address-guest ng-if="$ctrl.checkoutService.isDelivery()"></address-guest>
        <payment-guest ng-if="!$ctrl.loading"></payment-guest>
        <oo-card>
            <oo-card-header>Promo Code</oo-card-header>
            <oo-card-body>
                <promo-code></promo-code>
            </oo-card-body>
        </oo-card>
    `,
    controller: class {
        constructor(accountService, checkoutService, paymentService, $q, loginModalService) {
            'ngInject';
            this.accountService = accountService;
            this.checkoutService = checkoutService;
            this.paymentService = paymentService;
            this.$q = $q;
            this.loginModal = loginModalService;
        }

        $onInit() {
            this.$q.all([
                this.checkoutService.initialize(),
                this.accountService.getBasicInfo()
            ])
                .finally(() => this.loading = false);
        }

        isDelivery() {
            return this.checkoutService.isDelivery();
        }

        $onDestroy() {
            this.paymentService.clearCreditCardPayment();
        }

        popupLogin() {
            this.loginModal.open();
        }
    }
};
